<template>
  <label class="switch">
    <input type="checkbox" :checked="modelValue" @change="handleChange" />
    <span class="slider">
      <span class="knob"></span>
    </span>
  </label>
</template>

<script>
export default {
  name: "CustomSwitch",
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    trueColor: {
      type: String,
      default: "#6a9b23"
    },
    falseColor: {
      type: String,
      default: "#ffffff"
    },
    trueThumbColor: {
      type: String,
      default: "#ffffff"
    },
    falseThumbColor: {
      type: String,
      default: "#b9b9b9"
    }
  },
  methods: {
    handleChange(value) {
      this.$emit("update:modelValue", value.target.checked);
      this.$emit("update", value.target.checked);
    }
  }
};
</script>

<style scoped>
/* CSS para versão Desktop */
@media (min-width: 1200px) and (orientation: landscape) {
  .switch {
    position: relative;
    display: inline-block;
    width: 2.2vw;
    height: 1vw;
  }
  .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: v-bind(falseColor);
    transition: 0.4s;
    border: 0.1vw solid #e8e9e9;
    border-radius: 5vw;
  }
  .knob {
    position: absolute;
    content: "";
    height: 1.2vw;
    width: 1.2vw;
    left: -0.15vw;
    bottom: -0.15vw;
    background-color: v-bind(falseThumbColor);
    transition: 0.4s;
    border: 0.2vw solid #ffffff;
    border-radius: 50%;
  }
  input:checked + .slider {
    background-color: v-bind(trueColor);
    border: 0.15vw solid v-bind(trueColor);
    border: none;
  }
  input:checked + .slider .knob {
    background-color: v-bind(trueThumbColor);
    border: 0.2vw solid #fafafa;
    transform: translate(1.3vw, -0.1vw);
  }
}

/* CSS para versão Tablet na horizontal */
@media (max-width: 1200px) and (min-height: 600px) and (orientation: landscape) {
  .switch {
    position: relative;
    display: inline-block;
    width: 2.8vw;
    height: 1.5vw;
  }
  .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: v-bind(falseColor);
    transition: 0.4s;
    border: 0.1vw solid #e8e9e9;
    border-radius: 5vw;
  }
  .knob {
    position: absolute;
    content: "";
    height: 1.7vw;
    width: 1.7vw;
    left: -0.15vw;
    bottom: -0.2vw;
    background-color: v-bind(falseThumbColor);
    transition: 0.4s;
    border: 0.2vw solid #ffffff;
    border-radius: 50%;
  }
  input:checked + .slider {
    background-color: v-bind(trueColor);
    border: 0.15vw solid v-bind(trueColor);
    border: none;
  }
  input:checked + .slider .knob {
    background-color: v-bind(trueThumbColor);
    border: 0.2vw solid #fafafa;
    transform: translate(1.5vw, -0.1vw);
  }
}

/* CSS para versão Tablet na vertical */
@media (min-width: 600px) and (orientation: portrait) {
  .switch {
    position: relative;
    display: inline-block;
    width: 4.5vh;
    height: 2vh;
  }
  .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: v-bind(falseColor);
    transition: 0.4s;
    border: 0.1vh solid #e8e9e9;
    border-radius: 5vh;
  }
  .knob {
    position: absolute;
    content: "";
    height: 2.2vh;
    width: 2.2vh;
    left: -0.15vh;
    bottom: -0.2vh;
    background-color: v-bind(falseThumbColor);
    transition: 0.4s;
    border: 0.2vh solid #ffffff;
    border-radius: 50%;
  }
  input:checked + .slider {
    background-color: v-bind(trueColor);
    border: 0.15vh solid v-bind(trueColor);
    border: none;
  }
  input:checked + .slider .knob {
    background-color: v-bind(trueThumbColor);
    border: 0.2vh solid #fafafa;
    transform: translate(2.5vh, -0.1vh);
  }
}

/* CSS para versão Mobile na horizontal */
@media (max-width: 1024px) and (max-height: 600px) and (orientation: landscape) {
  .switch {
    position: relative;
    display: inline-block;
    width: 4.5vw;
    height: 2.2vw;
  }
  .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: v-bind(falseColor);
    transition: 0.4s;
    border: 0.1vw solid #e8e9e9;
    border-radius: 5vw;
  }
  .knob {
    position: absolute;
    content: "";
    height: 2.5vw;
    width: 2.5vw;
    left: -0.15vw;
    bottom: -0.2vw;
    background-color: v-bind(falseThumbColor);
    transition: 0.4s;
    border: 0.2vw solid #ffffff;
    border-radius: 50%;
  }
  input:checked + .slider {
    background-color: v-bind(trueColor);
    border: 0.15vw solid v-bind(trueColor);
    border: none;
  }
  input:checked + .slider .knob {
    background-color: v-bind(trueThumbColor);
    border: 0.2vw solid #fafafa;
    transform: translate(2.5vw, -0.1vw);
  }
}

/* CSS para versão Mobile na vertical */
@media (max-width: 600px) and (orientation: portrait) {
  .switch {
    position: relative;
    display: inline-block;
    width: 4.5vh;
    height: 2.2vh;
  }
  .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: v-bind(falseColor);
    transition: 0.4s;
    border: 0.1vh solid #e8e9e9;
    border-radius: 5vh;
  }
  .knob {
    position: absolute;
    content: "";
    height: 2.5vh;
    width: 2.5vh;
    left: -0.15vh;
    bottom: -0.2vh;
    background-color: v-bind(falseThumbColor);
    transition: 0.4s;
    border: 0.2vh solid #ffffff;
    border-radius: 50%;
  }
  input:checked + .slider {
    background-color: v-bind(trueColor);
    border: 0.15vh solid v-bind(trueColor);
    border: none;
  }
  input:checked + .slider .knob {
    background-color: v-bind(trueThumbColor);
    border: 0.2vh solid #fafafa;
    transform: translate(2.5vh, -0.1vh);
  }
}
.custom-switcher {
  display: inline-block;
}
.switch input {
  display: none;
}
</style>
